import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatForeignUserDetail,
	formatForeignUserList,
} from './foreign-user.helper';
import { ForeignUserActions } from './foreign-user.redux';
import {
	IPayloadCreateForeignUserRequest,
	IPayloadDeleteForeignUserRequest,
	IPayloadGetForeignUserDetailRequest,
	IPayloadGetForeignUserListRequest,
} from './foreign-user.type';

export function* getForeignUserList(
	action: PayloadAction<IPayloadGetForeignUserListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignUserListResponse> =
			yield API.getForeignUserList({ searchTypes, ...rest });

		const content = formatForeignUserList(res?.data?.content);

		yield put(
			ForeignUserActions.getForeignUserListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignUserActions.getForeignUserListFailure());
	}
}

export function* createForeignUsers(
	action: PayloadAction<IPayloadCreateForeignUserRequest>
) {
	const { callback, ...props } = action.payload;

	try {
		yield API.createForeignUser({
			...props,
		});

		yield put(ForeignUserActions.createForeignUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignUserActions.createForeignUserFailure());
	}
}

export function* deleteForeignUsers(
	action: PayloadAction<IPayloadDeleteForeignUserRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteForeignUser(ids);

		yield put(ForeignUserActions.deleteForeignUserSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignUserActions.deleteForeignUserFailure());
	}
}

export function* getForeignUserDetail(
	action: PayloadAction<IPayloadGetForeignUserDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IForeignUser> =
			yield API.getForeignUserDetail(id);

		const foreignUserDetail = formatForeignUserDetail(res.data);

		yield put(
			ForeignUserActions.getForeignUserDetailSuccess({
				foreignUserDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignUserActions.getForeignUserDetailFailure());
	}
}
